module.exports = __webpack_public_path__ + "img/icon-payment-bank - Copy.2f78bf27.png";